module.exports = __webpack_public_path__ + "img/icon-resize.921af36b.svg";